<apiz-grid-headless
  #grid
  class="apiz-grid-headless"
  [border]="!isTabTopLevel"
  [cacheRowCount]="cacheBlockSize"
  [columnDefs]="columnsTableHeader"
  [components]="data.frameworkComponents"
  [getContextMenuItems]="getContextMenuItems"
  [initAutosizeBehavior]="initAutosizeBehavior"
  [maxCacheRowCount]="cacheBlockSize"
  [mergedPanels]="!isTabTopLevel || isOneColumn || isMobile"
  [pagination]="pagination"
  [paginationPageCountOption]="isTabTopLevel ? 'AUTO' : paginationPageSize ? paginationPageSize : 10"
  [paginationPageCountOptions]="paginationOption"
  [rowMultiSelectWithClick]="rowMultiSelectWithClick"
  [rowSelection]="rowSelection"
  [rowSelectionOnCellClicked]="!suppressRowClickSelection"
  (allSelected)="onRowSelected($event)"
  (cellClicked)="onCellClicked($event)"
  (dataStateChanged)="onDataStateChanged($event)"
  (gridReady)="onGridReady($event)"
  (pageChanged)="onPageChange()"
  (rowSelected)="onRowSelected($event)">
  @if (data.isHighVolume) {
    <div azProjectAs="empty-overlay" class="apiz-gridtab-empty-overlay">
      <i class="az-filter"></i>
      <span class="main-reason"> {{ 'grid.empty-high-volume.main' | translate }}</span>
      <span class="reason-description">{{ 'grid.empty-high-volume.description' | translate }}</span>
    </div>
  }
</apiz-grid-headless>
